import React from 'react';
import { view } from 'react-easy-state';
import Store from '../store/store';
import { withTranslation } from 'react-i18next';

const PrestName = ({ idx, onClick, t }) => {
  const { prestazioni } = Store;
  const prestazione = prestazioni[idx];
  const { showModBtn } = Store;

  const onClickPrest = (e) => {
      onClick(e);
  }

  const selModCont = () => (
    <div className="kfpr-sel-mod-cont">
      <div className="kfpr-sel displaynone kfpr-sel-nolink">{prestazione.get('name')}</div>
      {
        showModBtn(idx) && 
        <div role="button" className="kfpr-modprest button small kf-azzurro-bg" onClick={onClickPrest}>
          {t('Modifica Prestazione')}
        </div>
      }
    </div>
  );

  return (
      <div>
        <span>{t("Prestazione")}</span>        
        {
        prestazione.get('name') ? 
            selModCont() :
            <strong>{t("Cerca la Prestazione")}</strong>
        }
      </div>
  )
}

export default withTranslation()(view(PrestName));


